import { useState } from 'react';
import { MenuItem, Select } from 'ui';

import { RiskScoreDescriptionEnum, type RiskScores } from '../../types';

export const RiskSelect = ({
  onChange,
  currentValue,
}: {
  onChange: (newRisk: RiskScores | null) => void;
  currentValue: RiskScores | null;
}) => {
  const [value, setValue] = useState<RiskScores | ''>(currentValue || '');

  return (
    <Select
      size="small"
      value={value}
      displayEmpty
      data-testid="risk-select"
      fullWidth={false}
      onChange={(e) => {
        if (!e.target.value) {
          setValue('');
          onChange(null);
          return;
        }
        const newRisk = e.target.value as RiskScores;
        setValue(newRisk);
        onChange(newRisk);
      }}
    >
      <MenuItem value="" hidden>
        Unknown
      </MenuItem>
      {Object.keys(RiskScoreDescriptionEnum).map((key) => (
        <MenuItem key={key} value={key}>
          {RiskScoreDescriptionEnum[key as RiskScores]}
        </MenuItem>
      ))}
    </Select>
  );
};
